import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { navigationKeeperIdAtom } from '@/atoms/navigation';
import { DEFAULT_KEEPER_BASE_ROUTE, useKeeperNavigationItems } from './subNavigation/useKeeperNavigationItems';

export const useKeeperNavigationItem = () => {
  const { t } = useTranslation(['navigation']);
  const keeperIqId = useAtomValue(navigationKeeperIdAtom);
  const keeperRoute = `${DEFAULT_KEEPER_BASE_ROUTE}/${keeperIqId}`;

  return {
    id: 'keeper',
    icon: 'Goalkeeper' as const,
    label: t('crossPlatform.primary.goalkeepers'),
    subNav: useKeeperNavigationItems(),
    path: `${keeperRoute}/overview`,
  };
};
